const actionTypeIdentifier = 'A4E1C3B9-4F2D-4C8A-B1E0-9D7F6C5B4A32';
export const getCustomerCreditCardInfo = `GET-CUSTOMER-CREDIT-CARD-INFO-${actionTypeIdentifier}`;
export const setCustomerCreditCardInfoError = `SET-CUSTOMER-CREDIT-CARD-INFO-ERROR-${actionTypeIdentifier}`;
export const setSuccessMessage = `SET-SUCCESS-MESSAGE-${actionTypeIdentifier}`;
export const getVitualCard = `SET-VIRTUAL-CARD-${actionTypeIdentifier}`;
export const resetVirtualCard = `RESET-VIRTUAL-CARD-${actionTypeIdentifier}`;